import { createApiAction } from '@app/packages/api/utils'
import type { V3GetAppConfigResponse } from '@app/packages/api/v3/types/responses'

export const getAppConfig = () =>
  createApiAction('getAppConfig', dispatch =>
    dispatch<V3GetAppConfigResponse>({
      endpoint: '/api/v3/app_config',
      method: 'GET',
    })
  )
